import {css} from 'styled-components';

// Scoped syntax highlighting for the time being until our designs and
// design system is more stable. prismjs.css has global styles and it's
// too risky to make changes there right now since we don't know the extent
// of how many components will be affected.
export const PRISM_OVERRIDES = css`
  &.language-javascript,
  html[data-dark-mode='true'] & {
    .token.comment,
    .token.prolog,
    .token.doctype {
      color: #6a9955;
    }

    .token.string {
      color: #ce9178;
    }

    .token.keyword {
      color: #569cd6;
    }

    .token.number {
      color: #b5cea8;
    }

    .token.function {
      color: #dcdcaa;
    }

    .token.class-name,
    .token.type,
    .token.type-annotation {
      color: #4ec9b0;
    }

    .token.variable,
    .token.parameter {
      color: #9cdcfe;
    }

    .token.operator,
    .token.punctuation,
    .token.entity,
    .token.url,
    .token.atrule,
    .token.attr-value {
      color: #d4d4d4;
    }
  }

  &.language-python {
    .token.comment,
    .token.prolog,
    .token.doctype {
      color: #008000;
    }

    .token.punctuation {
      color: #000000;
    }

    .namespace {
      opacity: 0.7;
    }

    .token.property,
    .token.tag,
    .token.boolean,
    .token.number,
    .token.constant,
    .token.symbol,
    .token.deleted {
      color: #098658 !important;
    }

    .token.selector,
    .token.attr-name,
    .token.char,
    .token.builtin,
    .token.inserted {
      color: #795e26;
    }

    .token.string {
      color: #a31515;
    }

    .token.cdata {
      color: #098658;
    }

    .token.operator,
    .token.entity,
    .token.url,
    .language-css .token.string,
    .style .token.string {
      color: #9a6e3a;
    }

    .token.atrule,
    .token.attr-value,
    .token.keyword {
      color: #af00db;
    }

    .token.function,
    .token.class-name {
      color: #dd4a68;
    }

    .token.regex,
    .token.important,
    .token.variable {
      color: #001080;
    }

    .token.important,
    .token.bold {
      font-weight: bold;
    }
    .token.italic {
      font-style: italic;
    }

    .token.entity {
      cursor: help;
    }
  }
`;
